module.exports = __webpack_public_path__ + "img/ring_g_e_0_0.a070e546.png";